import React from "react";

export const PatientProfileIcon: React.FC = () => {
  return (
    <svg
      width="39px"
      height="36px"
      viewBox="0 0 39 36"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <defs>
        <path
          d="M12,0 L12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 L24,12 C24,18.627417 18.627417,24 12,24 L12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 L0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
          id="path-1"
        ></path>
        <filter
          x="-54.2%"
          y="-45.8%"
          width="208.3%"
          height="208.3%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="4"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CareGEM-Provider-Global-navigation-V2.3"
          transform="translate(-14.000000, -689.000000)"
        >
          <g
            id="Fluid-MetricsFluid-Metrics-Copy-33"
            transform="translate(14.000000, 689.000000)"
          >
            <g id="Group-6" transform="translate(7.000000, 6.000000)">
              <g id="Rectangle-Copy-211">
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-2)"
                  xlinkHref="#path-1"
                ></use>
                <use
                  fill="#F1D22F"
                  fillRule="evenodd"
                  xlinkHref="#path-1"
                ></use>
              </g>
              <path
                d="M16.8035714,15.375 C16.9375007,15.375 17.0513388,15.4218745 17.1450893,15.515625 C17.2388398,15.6093755 17.2857143,15.7232136 17.2857143,15.8571429 C17.2857143,15.9910721 17.2388398,16.1049102 17.1450893,16.1986607 C17.0513388,16.2924112 16.9375007,16.3392857 16.8035714,16.3392857 L15.625,16.3392857 L15.625,17.5178571 C15.625,17.6517864 15.5781255,17.7656245 15.484375,17.859375 C15.3906245,17.9531255 15.2767864,18 15.1428571,18 C15.0089279,18 14.8950898,17.9531255 14.8013393,17.859375 C14.7075888,17.7656245 14.6607143,17.6517864 14.6607143,17.5178571 L14.6607143,16.3392857 L13.4821429,16.3392857 C13.3482136,16.3392857 13.2343755,16.2924112 13.140625,16.1986607 C13.0468745,16.1049102 13,15.9910721 13,15.8571429 C13,15.7232136 13.0468745,15.6093755 13.140625,15.515625 C13.2343755,15.4218745 13.3482136,15.375 13.4821429,15.375 L14.6607143,15.375 L14.6607143,14.1964286 C14.6607143,14.0624993 14.7075888,13.9486612 14.8013393,13.8549107 C14.8950898,13.7611602 15.0089279,13.7142857 15.1428571,13.7142857 C15.2767864,13.7142857 15.3906245,13.7611602 15.484375,13.8549107 C15.5781255,13.9486612 15.625,14.0624993 15.625,14.1964286 L15.625,15.375 L16.8035714,15.375 Z M14.2589286,11.1294643 C13.6785685,11.7187529 12.9732184,12.0133929 12.1428571,12.0133929 C11.3124958,12.0133929 10.6049136,11.7187529 10.0200893,11.1294643 C9.43526493,10.5401756 9.14285714,9.83259342 9.14285714,9.00669643 C9.14285714,8.18079944 9.43526493,7.47321723 10.0200893,6.88392857 C10.6049136,6.29463991 11.3124958,6 12.1428571,6 C12.9732184,6 13.6808006,6.29463991 14.265625,6.88392857 C14.8504494,7.47321723 15.1428571,8.18079944 15.1428571,9.00669643 C15.1428571,9.83259342 14.8482172,10.5401756 14.2589286,11.1294643 Z M13.5758929,10.4598214 C13.9776806,10.0580337 14.1785714,9.57366355 14.1785714,9.00669643 C14.1785714,8.43972931 13.9799127,7.95759127 13.5825893,7.56026786 C13.1852659,7.16294444 12.70536,6.96428571 12.1428571,6.96428571 C11.5803543,6.96428571 11.1004484,7.16294444 10.703125,7.56026786 C10.3058016,7.95759127 10.1071429,8.43972931 10.1071429,9.00669643 C10.1071429,9.57366355 10.3058016,10.0558016 10.703125,10.453125 C11.1004484,10.8504484 11.5803543,11.0491071 12.1428571,11.0491071 C12.70536,11.0491071 13.1830337,10.8526805 13.5758929,10.4598214 Z M14.9553571,12.8571429 C14.4821405,12.8839287 14.0401806,13.0178559 13.6294643,13.2589286 C13.1562476,13.0714276 12.6607169,12.9776786 12.1428571,12.9776786 C10.9910657,12.9776786 10.0067005,13.3861566 9.18973214,14.203125 C8.37276377,15.0200934 7.96428571,16.0089228 7.96428571,17.1696429 C7.96428571,17.1785715 7.96428571,17.1875 7.96428571,17.1964286 C7.96428571,17.3303578 7.91741118,17.444196 7.82366071,17.5379464 C7.72991025,17.6316969 7.6160721,17.6785714 7.48214286,17.6785714 C7.34821362,17.6785714 7.23437547,17.6316969 7.140625,17.5379464 C7.04687453,17.444196 7,17.3303578 7,17.1964286 C7,17.1964286 7,17.1919643 7,17.1830357 C7,17.1741071 7,17.1696429 7,17.1696429 C7,16.2321382 7.22990842,15.3683075 7.68973214,14.578125 C8.14955587,13.7879425 8.77454962,13.1629487 9.56473214,12.703125 C10.3549147,12.2433013 11.2142811,12.0133929 12.1428571,12.0133929 C13.169648,12.0133929 14.1071386,12.29464 14.9553571,12.8571429 Z M10.0857143,9.16633533 L13.0646542,6.79350872 L13.8243928,7.43108941 L10.3076552,10.1360159 L10.0857143,9.16633533 Z"
                id="Patient-Profile"
                stroke="#FFFFFF"
                strokeWidth="0.5"
                fill="#FFFFFF"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
